import { render, staticRenderFns } from "./ConfirmBeOwner.vue?vue&type=template&id=79637c6d&scoped=true&"
import script from "./ConfirmBeOwner.vue?vue&type=script&lang=js&"
export * from "./ConfirmBeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79637c6d",
  null
  
)

export default component.exports